import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StatePromissoryNote.json';
import FormError from '../../../../view/FormError';
import {Currency, UnCurrency} from '../../../../model/Helper';
import Meta from '../../../../model/Meta';

class PromissoryNoteStep3 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;
		
		this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));
					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(e, radioName=null) {

		const target = e.target;
		let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = radioName ? radioName : target.name;
        
        if(name==="principal") {
            value = UnCurrency(value);
			if(value.length>15){
				value = this.state.details.loan.principal;
			}
        }
        
        if(name==="interestRate") {
			if(value.length>5){
				value = this.state.details.loan.interestRate;
			}
        }
        
        if(name==="duration") {
			if(value>600){
				value = this.state.details.loan.duration;
			}
		}

		this.setState({
			details: {
				property: this.state.details.property,
				borrower: this.state.details.borrower,
				lender: this.state.details.lender,
				loan: {
                    ...this.state.details.loan,
                    [name]: value
                }
			},
			formFocus: `loan_`+name
		},
			()=>{
				this.setState(this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				this.errorHandle();

			}
		);
	}
	
	errorHandle(callback = null) {
		// Check if we have a user borrower
		let errorArray = [];
        
        if(!this.state.details.loan.principal){
            let err = {
                "message": `Please enter principal amount.`
            }
            errorArray.push(err);
        }

        if(!this.state.details.loan.interestRate){
            let err = {
                "message": `Please enter interest rate.`
            }
            errorArray.push(err);
        }

        if(!this.state.details.loan.duration){
            let err = {
                "message": `Please enter duration.`
            }
            errorArray.push(err);
        }

        //console.log("Going to state: ", errorArray)

        this.setState({
            formError: errorArray
        },(i)=>{
            ////console.log("Error handle: ", this.state )
            localStorage.setItem(this.state.formId, JSON.stringify(this.state));
            this.checkCompleteness();		
        })

	}

    checkCompleteness() {

		if(this.state.formError.length>0) {
            $(".next").addClass("disabled");
            $(".form-error").removeClass("d-none");
		} else {
            $(".next").removeClass("disabled");
            $(".form-error").addClass("d-none");
		}
			
	}
    
    render() {
        const meta = {
            title: "Loan information - Create custom Promissory Note free",
            description: "Enter loan information - Create custom Promissory Note and download as PDF free"
        }
        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((3/4)*100)} />

                                <form>
                                    
                                    <div className="form-group">
                                        <label htmlFor="principal">
                                            <span className="font-weight-bold">How much is the principal amount to be borrowed?</span><span className="red asterisk">*</span>
                                        </label>
                                        <input className="form-control" name="principal" type="text" onChange={this.handleChange} value={Currency(this.state.details.loan.principal)} placeholder="(e.g. 50,000)" />
                                    </div>

                                    <div>
                                        <p className="label"><strong>Will the interest rate be on a monthly or yearly basis?<span className="red asterisk">*</span></strong></p>
                                        <div className="row text-center">
                                        
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="Monthly" 
                                                            onChange={(e)=>this.handleChange(e, "interestRateBasis")} 
                                                            checked={this.state.details.loan.interestRateBasis === 'Monthly'} 
                                                        />
                                                            Monthly
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="Yearly" 
                                                            onChange={(e)=>this.handleChange(e, "interestRateBasis")} 
                                                            checked={this.state.details.loan.interestRateBasis === 'Yearly'} 
                                                        />
                                                            Yearly
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={!this.state.details.loan.interestRateBasis?`d-none`:``}>

                                        <div className="form-group interest-rate">
                                            <label htmlFor="interestRate">
                                                <span className="font-weight-bold">How much is the interest rate? (%)</span><span className="red asterisk">*</span>
                                            </label>
                                            <input className="form-control" name="interestRate" type="number" onChange={this.handleChange} value={this.state.details.loan.interestRate} placeholder="(e.g. 3)" />
                                        </div>

                                        <div className="form-group duration">
                                            <label htmlFor="duration">
                                                <span className="font-weight-bold">How many {this.state.details.loan.interestRateBasis==="Monthly" ? `months` : `years`} will the duration of the loan be?</span><span className="red asterisk">*</span>
                                            </label>
                                            <input className="form-control" name="duration" type="number" onChange={this.handleChange} value={this.state.details.loan.duration} placeholder="(e.g. 12)" />
                                        </div>

                                        {/** Conditional div */}
                                        <div className={this.state.details.loan.interestRateBasis==="Yearly"?``:`d-none`}>
                                            <div>
                                                <p className="label"><strong>At what interval will the amortization/installment be paid<span className="red asterisk">*</span></strong></p>
                                                <div className="row text-center">
                                                
                                                    <div className="col-6">
                                                        <div className="form-check form-check-inline mr-2">
                                                            <label className="form-check-label">
                                                                <input 
                                                                    className="form-check-input" 
                                                                    type="radio" 
                                                                    value="Monthly" 
                                                                    onChange={(e)=>this.handleChange(e, "interval")} 
                                                                    checked={this.state.details.loan.interval === 'Monthly'} 
                                                                />
                                                                    Monthly
                                                                </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-check form-check-inline ml-2">
                                                            <label className="form-check-label">
                                                                <input 
                                                                    className="form-check-input" 
                                                                    type="radio" 
                                                                    value="Yearly" 
                                                                    onChange={(e)=>this.handleChange(e, "interval")} 
                                                                    checked={this.state.details.loan.interval === 'Yearly'} 
                                                                />
                                                                    Yearly
                                                                </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group first-installment">
                                            <label htmlFor="firstInstallment">
                                                <span className="font-weight-bold">What date will the first installment be due and demandable?</span><span className="red asterisk">*</span>
                                                
                                            </label>
                                            <input className="form-control" name="firstInstallment" type="date" onChange={this.handleChange} value={this.state.details.loan.firstInstallment} placeholder="(e.g. 1 January 2017)" />
                                        </div>

                                        {/** Principal demandable */}
                                        <div className={this.state.details.loan.interestRateBasis==="Yearly" && this.state.details.loan.interval==="Monthly" ? `d-none` : ``}>
                                            <p className="label"><strong>When will the principal amount be due and demandable?<span className="red asterisk">*</span></strong></p>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-check form-check-inline ml-2">
                                                        <label className="form-check-label">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="radio" 
                                                                value="Pro rated on the number of installments" 
                                                                onChange={(e)=>this.handleChange(e, "principalDemandable")} 
                                                                checked={this.state.details.loan.principalDemandable === 'Pro rated on the number of installments'} 
                                                            />
                                                                Pro rated on the number of installments
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-check form-check-inline ml-2">
                                                        <label className="form-check-label">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="radio" 
                                                                value="On the last installment" 
                                                                onChange={(e)=>this.handleChange(e, "principalDemandable")} 
                                                                checked={this.state.details.loan.principalDemandable === 'On the last installment'} 
                                                            />
                                                                On the last installment
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/** Computation for interest  */}
                                        <div className={this.state.details.loan.interestRateBasis==="Yearly" && this.state.details.loan.interval==="Monthly" ? `` : `d-none`}>
                                            <div>
                                                <p className="label"><strong>Computation for the interest<span className="red asterisk">*</span></strong></p>
                                                <div className="row text-center">
                                                
                                                    <div className="col-6">
                                                        <div className="form-check form-check-inline mr-2">
                                                            <label className="form-check-label">
                                                                <input 
                                                                    className="form-check-input" 
                                                                    type="radio" 
                                                                    value="Simple/Straight Computation" 
                                                                    onChange={(e)=>this.handleChange(e, "computationOfInterest")} 
                                                                    checked={this.state.details.loan.computationOfInterest === 'Simple/Straight Computation'} 
                                                                />
                                                                    Simple/Straight Computation
                                                                </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-check form-check-inline ml-2">
                                                            <label className="form-check-label">
                                                                <input 
                                                                    className="form-check-input" 
                                                                    type="radio" 
                                                                    value="Diminishing Balance" 
                                                                    onChange={(e)=>this.handleChange(e, "computationOfInterest")} 
                                                                    checked={this.state.details.loan.computationOfInterest === 'Diminishing Balance'} 
                                                                />
                                                                    Diminishing Balance
                                                                </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 3/4</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/2"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/4"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>

                                <div className="alert alert-secondary">
                                    <div className="small">
                                        <div><strong>*Pro rated on the number of installments</strong></div>
                                        <div>e.g.</div>
                                        <ul>
                                            <li>P100,000.00 (loaned amount) plus P18,000.00 (total interest amount) = P118,000.00 (total amount to be paid by the mortgagee)</li>
                                            <li>P118,000.00 (total amount) divided by 6 (number of months) = P19,666.67 (monthly amortization)</li>
                                            <li>P19,666.67 is the monthly amortization the mortgagee has to pay for six months totalling P118,000.00</li>
                                        </ul>

                                        <div><strong>*On the last installment</strong></div>
                                        <div>e.g.</div>
                                        <ul>
                                            <li>3% (monthly interest rate) multiplied by P100,000.00 (loaned amount) = P3,000.00 (monthly interest amount)</li>
                                            <li>P3,000.00 is the monthly amortization the mortgagee has to pay for six months totalling P18,000.00</li>
                                            <li>On the sixth amortization, aside from the above P3,000.00 interest amount, the mortgagee shall likewise pay the principal amount of P100,000.00 or a total of P103,000.00</li>
                                        </ul>

                                    </div>
                                </div>
                            
                            </div>

                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>
                         
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default PromissoryNoteStep3;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/promissory-note/PromissoryNoteStep3.js